/**
 * Schaff Trend Cycle (STC) Indicator Wrapper
 *
 * Wraps the schaffTrendCycle calculator with the standard indicator interface.
 * The STC is a double-smoothed stochastic of MACD that oscillates between 0 and 100.
 */

import { rebind, merge } from "../utils";
import { schaffTrendCycle } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "SchaffTrendCycle";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.schaffTrendCycle);

  const underlyingAlgorithm = schaffTrendCycle();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.schaffTrendCycle = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
